import React, { ReactElement, useCallback, useEffect, useState } from "react"
import { Grid, Box } from "@material-ui/core"
import { ReactourStep } from "reactour"
import { PageContainer } from "../../components/Layouts"
import PageTip from "../../components/PageTip"
import Step6Form from "../../components/Forms/Planing/Step6"
import ControlPanelPlaning from "../../components/CFC/ControlPanelPlaning"
import PageTour from "../../components/PageTour"
import {
	CFC4QsTourContent,
	CFCCreateCanvas,
} from "../../components/CFC/__config/constants"
import MasterTablePlaning from "../../components/Forms/Planing/MasterTable"
import { useParams } from "react-router-dom"
import CFCUseCase from "../../data/CFC/CFCLogic"

const steps: ReactourStep[] = [
	{
		selector: "[data-reactour='four-questions-nav']",
		content: CFC4QsTourContent,
	},
	{
		selector: "[data-reactour='create-a-canvas']",
		content: CFCCreateCanvas,
	},
]

/**
 * Create a CFC page
 *
 * @export
 * @returns {ReactElement}
 */
export default function PlaningCanvasStep6(): ReactElement {
	const [ukupniTroskovi, setUkupniTroskovi] = useState()
	const [ukupniPrihodi, setUkupniPrihodi] = useState()
	const [ukupnoTrajanje, setUkupnoTrajanje] = useState()
	const [values, setValues] = useState<any>()
	const { id: canvasId } = useParams<any>()

	const osveziMaster = (values: any) => {
		setUkupniTroskovi(values.ukupniTroskovi)
		setUkupniPrihodi(values.ukupniPrihodi)
		setUkupnoTrajanje(values.ukupnoTrajanje)
	}

	const [loadData, setLoadData] = useState(false)

	const fetchFormData = useCallback(async () => {
		const data = await CFCUseCase.findById(canvasId)
		if (data) {
			setValues(data)
			setLoadData(true)
		} else {
			setLoadData(true)
		}
	}, [])

	useEffect(() => {
		fetchFormData()
	}, [])

	if (!loadData) {
		return <div>Loading...</div>
	}

	return (
		<>
			<PageContainer maxWidth="xl" role="main">
				<Grid container spacing={1}>
					<Grid item xs={12} md={12}>
						<Step6Form osveziMaster={osveziMaster} values={values} />
					</Grid>
					{/* <Grid item xs={12} md={2}> */}
					{/* <ControlPanelPlaning /> */}
					{/* <MasterTablePlaning /> */}
					{/* </Grid> */}
				</Grid>
			</PageContainer>
			<PageTip tip="CFCanvasTip" />
			{/* <Box role="complementary">
				<PageTour steps={steps} />
			</Box> */}
		</>
	)
}
